import * as React from 'react'
import DashboardOrdersTable from 'src/pages/fuel-trading/dashboard-orders-table'
import { useQuery } from '@tanstack/react-query'
import axios from 'axios'
import { IOrder } from 'src/_models/order.model'
import { useEffect, useState } from 'react'

const DashboardOrdersCompleted = () => {
  const [orders, setOrders] = useState<IOrder[]>()
  const orderDisputedQuery = useQuery({
    queryKey: ['orders', 'orders/disputed'],
    queryFn: () => {
      const token = localStorage.getItem('token')
      return axios.get<IOrder[]>('/api/orders/disputed', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
    },
  })

  useEffect(() => {
    if (orderDisputedQuery.data) {
      setOrders(orderDisputedQuery.data.data)
    }
  }, [orderDisputedQuery.data])

  return (
    <div className="w-1/2">
      {orders && (
        <DashboardOrdersTable heading="Disputed Orders" url="/fuel-trading/disputed" orders={orders as IOrder[]} />
      )}
    </div>
  )
}

export default DashboardOrdersCompleted
